/**
 * =============================================================================
 * COOKIE CONTEXT - Contexto React de Consentimento de Cookies
 * =============================================================================
 */

import { createContext } from "react";
import type { CookieCategories, ConsentRecord, SupportedLanguage } from "@/utils/cookieManager";

export interface CookieTranslations {
  bannerTitle: string;
  bannerDescription: string;
  acceptAll: string;
  rejectNonEssential: string;
  customize: string;
  preferencesTitle: string;
  preferencesDescription: string;
  savePreferences: string;
  necessary: string;
  analytics: string;
  marketing: string;
  preferences: string;
  alwaysActive: string;
  settingsLabel: string;
  close: string;
  cookiePolicy: string;
  privacyPolicy: string;
}

export interface CookieContextValue {
  consent: CookieCategories | null;
  record: ConsentRecord | null;
  isBannerOpen: boolean;
  isPreferencesOpen: boolean;
  isLoading: boolean;
  language: SupportedLanguage;
  t: CookieTranslations;
  acceptAll: () => void;
  rejectNonEssential: () => void;
  savePreferences: (categories: CookieCategories) => void;
  openBanner: () => void;
  closeBanner: () => void;
  openPreferences: () => void;
  closePreferences: () => void;
  hasConsent: (category: keyof CookieCategories) => boolean;
}

export const CookieContext = createContext<CookieContextValue | null>(null);

export default CookieContext;
